import revive_payload_client_4sVQNw7RlN from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_zlvi6dcIsi from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/.cache/nuxt/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_W5VNcGB8FU from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/nuxt-3-intercom/dist/runtime/plugin.client.mjs";
import fontawesome_7xXmPH2btU from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/@vesp/nuxt-fontawesome/dist/runtime/plugins/fontawesome.js";
import useDirectives_2KnF4DchlO from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/@bootstrap-vue-next/nuxt/dist/runtime/useDirectives.js";
import createBootstrap_Re1dxEZp3O from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/@bootstrap-vue-next/nuxt/dist/runtime/createBootstrap.js";
import plugin_L93bAIrZuZ from "C:/Projects/HUB/src/PublicSite/client-app/modules/auth/runtime/plugin.ts";
import plugin_sCUCl9N3S3 from "C:/Projects/HUB/src/PublicSite/client-app/modules/pinia-persisted-state/runtime/plugin.ts";
import emitter_NxDuCadL1G from "C:/Projects/HUB/src/PublicSite/client-app/app/plugins/emitter.ts";
import gtm_client_4NBdt7Mc3K from "C:/Projects/HUB/src/PublicSite/client-app/app/plugins/gtm.client.ts";
import non_fatal_error_handler_PVl7J2RkZX from "C:/Projects/HUB/src/PublicSite/client-app/app/plugins/non-fatal-error-handler.ts";
import vue_toastificaton_client_8rOjhsgfC1 from "C:/Projects/HUB/src/PublicSite/client-app/app/plugins/vue-toastificaton.client.ts";
import vue3_openlayers_client_kiOhizyR81 from "C:/Projects/HUB/src/PublicSite/client-app/app/plugins/vue3-openlayers.client.ts";
import plugin_client_8c7sclTFgz from "C:/Projects/HUB/src/PublicSite/client-app/node_modules/.cache/nuxt/.nuxt/nuxt-booster/plugin.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_zlvi6dcIsi,
  prefetch_client_5tzzN0oIVL,
  plugin_client_W5VNcGB8FU,
  fontawesome_7xXmPH2btU,
  useDirectives_2KnF4DchlO,
  createBootstrap_Re1dxEZp3O,
  plugin_L93bAIrZuZ,
  plugin_sCUCl9N3S3,
  emitter_NxDuCadL1G,
  gtm_client_4NBdt7Mc3K,
  non_fatal_error_handler_PVl7J2RkZX,
  vue_toastificaton_client_8rOjhsgfC1,
  vue3_openlayers_client_kiOhizyR81,
  plugin_client_8c7sclTFgz
]